module.exports = __webpack_public_path__ + "img/cTrader-icon1.150907c.png";